import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Card,
  Link,
  Alert,
  Hidden,
  Tooltip,
  Container,
  Typography,
  Grid
} from '@material-ui/core';
// routes
import { PATH_PAGE } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
// components
import Page from '../../components/Page';
import Logo from '../../components/Logo';
import { LoginForm } from '../../components/authentication/login';
import AuthWithSocial from '../../components/authentication/AuthWithSocial';
import ReactPlayer from 'react-player/lazy'; //see https://www.npmjs.com/package/react-player
import playSolid from '@iconify/icons-clarity/play-solid';
import { Icon } from '@iconify/react';

// ----------------------------------------------------------------------

const googleMediaUrl = process.env.REACT_APP_GOOGLE_MEDIA;
const filename_mp4 = googleMediaUrl + '1673030315_Playz_Kickoff3.mp4';
//const media_thumbnail = googleMediaUrl + '1673030342_thumb_6427e948-8df1-11ed-bc9d-42010a8e0002.jpg';
const media_thumbnail = googleMediaUrl + 'LED-Stadium-Lights.jpg';
const imageUrl_array = [filename_mp4];


const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  zIndex: 9,
  lineHeight: 0,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  position: 'absolute',
  padding: theme.spacing(3),
  justifyContent: 'space-between',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    padding: theme.spacing(7, 5, 0, 7)
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { method } = useAuth();

  return (
    <RootStyle title="Login | Playz">
      <HeaderStyle>
        <RouterLink to="/">
          <Logo logoheight={30} />
        </RouterLink>
        <Hidden smDown>
          <Typography
            variant="body2"
            sx={{
              mt: { md: -2 }
            }}
          >
            Don’t have an account? &nbsp;
            <Link
              underline="none"
              variant="subtitle2"
              component={RouterLink}
              to={PATH_PAGE.auth.register}
            >
              Get started
            </Link>
          </Typography>
        </Hidden>
      </HeaderStyle>

      <Hidden mdDown>
        <SectionStyle>
          <Typography variant="h3" sx={{ alignSelf: 'center', mt: 5, mb: 5 }}>
            Hi, Welcome Back
          </Typography>
          <Card style={{alignSelf: 'center', height: 500, width: 280}}>
            <ReactPlayer 
              controls={true}
              //controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
              width="100%"
              height="100%"
              light={media_thumbnail}
              url={imageUrl_array}
              playing={true}
              playIcon={
                <Typography variant="h5" style={{color: '#FFF', textShadow: '2px 2px #000000', textAlign: 'center', marginTop: 0}}>
                  Check out Playz...<br />
                  <Icon style={{ fontSize: 60, textShadow: '2px 2px #000000', marginTop: 18 }} icon={playSolid} color="#3176bb" />
                </Typography>
              }          
            />

          </Card>
        </SectionStyle>
      </Hidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Box sx={{ mb: 5, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                Sign in to Playz
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Enter your details below.
              </Typography>
            </Box>
            <Tooltip title={method === 'firebase' ? 'Firebase' : 'JWT'}>
              <Box
                component="img"
                src={`/static/icons/${
                  method === 'firebase' ? 'ic_firebase' : 'ic_jwt'
                }.png`}
                sx={{ width: 32, height: 32 }}
              />
            </Tooltip>
          </Box>

          {method === 'firebase' && <AuthWithSocial />}

          <LoginForm />

          <Typography variant="body2" align="center" sx={{ mt: 3 }}>
            Don’t have an account?&nbsp;
            <Link
              variant="subtitle2"
              component={RouterLink}
              to={PATH_PAGE.auth.register}
            >
              Get started
            </Link>
          </Typography>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
